// The client pages are reached from both the "client" and "ownclient" menus,
// so a permission is granted when either menu the role has access to allows it.
export const CLIENT_MENU_KEYS = ["client", "ownclient"];

export const hasClientPermission = (Menulist, permissionType) =>
  Array.isArray(Menulist) &&
  Menulist.some(
    (item) =>
      (CLIENT_MENU_KEYS.includes(item?.key) &&
        item?.access &&
        item?.permission?.[permissionType]) ||
      item?.subMenu?.some(
        (sub) =>
          CLIENT_MENU_KEYS.includes(sub?.key) &&
          sub?.access &&
          sub?.permission?.[permissionType]
      )
  );
